/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 * Лёгкая карточка инструкции без конструктора — единая структура для списка (GET /instructions) и поиска (GET /instructions/search); DTO — App\Service\Post\Content\Resolvers\Data\InstructionListItemData
 * @export
 * @interface InstructionCard
 */
export interface InstructionCard {
  /**
   * Заголовок инструкции
   * @type {string}
   * @memberof InstructionCard
   */
  title: string
  /**
   * Slug инструкции
   * @type {string}
   * @memberof InstructionCard
   */
  slug: string
  /**
   * Дата публикации, null — не задана
   * @type {Date}
   * @memberof InstructionCard
   */
  publishedAt?: Date | null
  /**
   * Порядок сортировки (meta.extra.sort_order), null — не задан
   * @type {number}
   * @memberof InstructionCard
   */
  order?: number | null
  /**
   * Краткое описание (meta.extra.short_description), null — не задано
   * @type {string}
   * @memberof InstructionCard
   */
  shortDescription?: string | null
}

/**
 * Check if a given object implements the InstructionCard interface.
 */
export function instanceOfInstructionCard(
  value: object
): value is InstructionCard {
  if (!('title' in value) || value['title'] === undefined) return false
  if (!('slug' in value) || value['slug'] === undefined) return false
  return true
}

export function InstructionCardFromJSON(json: any): InstructionCard {
  return InstructionCardFromJSONTyped(json, false)
}

export function InstructionCardFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): InstructionCard {
  if (json == null) {
    return json
  }
  return {
    title: json['title'],
    slug: json['slug'],
    publishedAt:
      json['publishedAt'] == null ? undefined : new Date(json['publishedAt']),
    order: json['order'] == null ? undefined : json['order'],
    shortDescription:
      json['shortDescription'] == null ? undefined : json['shortDescription'],
  }
}

export function InstructionCardToJSON(value?: InstructionCard | null): any {
  if (value == null) {
    return value
  }
  return {
    title: value['title'],
    slug: value['slug'],
    publishedAt:
      value['publishedAt'] == null
        ? undefined
        : (value['publishedAt'] as any).toISOString(),
    order: value['order'],
    shortDescription: value['shortDescription'],
  }
}
